const mutations = {
  getRates: (state, rate) => {
    state.rate = rate;
  },
  getReasons: (state, reason) => {
    state.reason = reason;
  },
  getReasonShipments: (state, reason_shipment) => {
    state.reason_shipment = reason_shipment;
  },
  getReasonFms: (state, reason_fm) => {
    state.reason_fm = reason_fm;
  },
  getReasonLms: (state, reason_lm) => {
    state.reason_lm = reason_lm;
  },
  getRate: (state, rate_id) => {
    state.rate_id = rate_id;
  },
  getReason: (state, reason_id) => {
    state.reason_id = reason_id;
  },
  postRate: (state, new_rate) => {
    state.rate.push(new_rate);
  },
  postReason: (state, new_reason) => {
    state.reason.push(new_reason);
  },
  updateRates: (state, new_status) => {
    state.rate = state.rate.map((rate) => {
      if (rate.id === new_status.rate_id) {
        return Object.assign({}, rate, new_status.status);
      }
      return rate;
    });
  },
  updateReasons: (state, new_status) => {
    state.reason = state.reason.map((reason) => {
      if (reason.id === new_status.reason_id) {
        return Object.assign({}, reason, new_status.status);
      }
      return reason;
    });
  },
  putRate: (state, payload) => {
    state.rate = state.rate.map((rate) => {
      if (rate.rate_id === payload.id) {
        return Object.assign({}, rate, payload.formData);
      }
      return rate;
    });
  },
  putReason: (state, payload) => {
    state.reason = state.reason.map((reason) => {
      if (reason.reason_id === payload.id) {
        return Object.assign({}, reason, payload.formData);
      }
      return reason;
    });
  },
  delRate(state, id) {
    const index = state.rate.findIndex(rate => rate.rate_id == id);
    state.rate.splice(index, 1);
  },
  delReason(state, id) {
    const index = state.reason.findIndex(reason => reason.reason_id == id);
    state.reason.splice(index, 1);
  },
};

export default mutations;
